<template>
  <v-select
    id="project-select"
    v-model="filter.projetoId"
    item-text="nome"
    item-name="projetoId"
    item-value="projetoId"
    :items="projects"
    label="Projeto"
    placeholder="Projeto"
    solo
    hide-details="auto"
    :disabled="disabled"
    clearable
    @change="
      (e) => {
        $emit('changeProject', filter.projetoId);
        $emit(
          'nameChange',
          this.projects
            .filter((val) => val.projetoId == filter.projetoId)
            .map((item) => item.nome)
        );
      }
    "
  >
    <template slot="no-data"> Nenhum Projeto retornado </template>
  </v-select>
</template>

<script>
import { projectAPI } from "./ProjectAPI";

export default {
  name: "AppProjectCombobox",
  props: ["filter", "disabled"],
  mounted() {
    this.loadProject();
  },
  methods: {
    loadProject() {
      projectAPI
        .list()
        .then((resp) => {
          this.projects = resp.data;
          this.$emit("projects", this.projects);
        })
        .catch();
    },
  },
  data() {
    return {
      projects: [],
    };
  },
};
</script>
